// extracted by mini-css-extract-plugin
export default {"nameCell":"domain-table-row_nameCell__y3wA9"};